import { render, staticRenderFns } from "./OverviewDashboard.vue?vue&type=template&id=5165e56c&scoped=true&"
import script from "./OverviewDashboard.vue?vue&type=script&lang=ts&"
export * from "./OverviewDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5165e56c",
  null
  
)

export default component.exports